/** User-created posts persisted in `localStorage`. `image` is a data URL or https URL. */

export type UserPost = {
  id: string;
  /** Data URL from file upload, or legacy image URL */
  image: string;
  author?: string;
  title: string;
  description: string;
  /** ISO date string */
  pubDate: string;
};

const POSTS_KEY = 'cm_posts';

function normalizePost(raw: unknown): UserPost | null {
  if (typeof raw !== 'object' || raw === null) return null;
  const r = raw as Record<string, unknown>;
  if (typeof r.id !== 'string') return null;

  const image =
    typeof r.image === 'string'
      ? r.image
      : typeof r.imageUrl === 'string'
        ? r.imageUrl
        : '';
  const pubDate =
    typeof r.pubDate === 'string'
      ? r.pubDate
      : typeof r.date === 'string'
        ? r.date
        : '';
  const description = typeof r.description === 'string' ? r.description : '';
  const title = typeof r.title === 'string' ? r.title : '';
  const author = typeof r.author === 'string' ? r.author : '';

  if (!image || !pubDate) return null;

  return {id: r.id, image, author: author ? author : undefined, title, description, pubDate};
}

export function loadPosts(): UserPost[] {
  try {
    const raw = localStorage.getItem(POSTS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizePost).filter((p): p is UserPost => p !== null);
  } catch {
    return [];
  }
}

export function savePosts(posts: UserPost[]): void {
  localStorage.setItem(POSTS_KEY, JSON.stringify(posts));
}
